<template>
    <div>
        <video
            id="my-player"
            class="video-js"
            :style="`width: ${videoSize.width}; height: ${videoSize.height};`"
            controls
            preload="auto"
            data-setup="{}"
        >
            <source :src="url">
            <p class="vjs-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that
                <a href="https://videojs.com/html5-video-support/" target="_blank">
                    supports HTML5 video
                </a>
            </p>
        </video>
    </div>
</template>

<script>
export default {
    props: {
        videoUrl: {
            type: String,
        },
        base64Url: {
            type: String,
        },
        isBase64: {
            type: Boolean,
            default: false
        },
        videoSize: {
            type: Object,
            default: function () {
                return {
                    width: "200px",
                    height: "100px"
                };
            },
        }
    },
    computed: {
        url() {
            if (this.isBase64) {
                return `data:video/mpeg;base64,${this.base64Url}`;
            }
            else {
                return this.videoUrl;
            }
        }
    }
};
</script>

<style lang="css" scoped>
.recording-video {
    width: 200px;
    height: 100px;
}
</style>


// WEBPACK FOOTER //
// src/components/VideoPlayer/index.vue